import { useState } from 'react'
import styles from '../../styles/user/Test.module.scss'
import { TestProps } from '../../types/test'
import FractionPreviewText from '../common/FractionPreviewText'

const Test = ({ questions, onSubmit }: TestProps) => {
  const [selectedAnswers, setSelectedAnswers] = useState<
    Record<number, number>
  >({})

  const handleSelectOption = (questionId: number, optionId: number) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionId]: optionId,
    }))
  }

  const handleSubmit = () => {
    onSubmit(selectedAnswers)
  }

  return (
    <div className={styles.testContainer}>
      {questions.map((question, index) => (
        <div key={question.id} className={styles.questionItem}>
          <h2 className={styles.questionTitle}>
            {String(index + 1).padStart(2, '0')}. <FractionPreviewText text={question.text} />
          </h2>

          {question.imageUrl && (
            <div className={styles.questionImage}>
              <img src={question.imageUrl} alt={question.text} />
            </div>
          )}

          {question.additionalText && (
            <div className={styles.additionalText}>
              <p><FractionPreviewText text={question.additionalText} /></p>
            </div>
          )}

          <div className={styles.optionsContainer}>
            {question.options.map((option) => (
              <button
                key={option.id}
                className={`${styles.optionButton} ${
                  selectedAnswers[question.id] === option.id
                    ? styles.selected
                    : ''
                }`}
                onClick={() => handleSelectOption(question.id, option.id)}
              >
                <FractionPreviewText text={option.text} />
              </button>
            ))}
          </div>
        </div>
      ))}

      <div className={styles.submitContainer}>
        <button className={styles.submitButton} onClick={handleSubmit}>
          Submit
        </button>
      </div>
    </div>
  )
}

export default Test
